import type { SettingsRepository } from '@obraplan/core/application/ports/repositories';
import type { Clock } from '@obraplan/core/application/ports/clock';
import type { ObraPlanDb } from './db';

/** As configurações do aparelho, no `appSettings` do banco do navegador. */
export class DexieSettingsRepository implements SettingsRepository {
  // O `Clock` é injetado mesmo aqui: `new Date()` só existe dentro de SystemClock,
  // sem exceção — é o que mantém toda regra dependente de tempo testável (RN-123).
  constructor(
    private readonly db: ObraPlanDb,
    private readonly clock: Clock,
  ) {}

  async get<T>(key: string): Promise<T | undefined> {
    const row = await this.db.appSettings.get(key);
    return row === undefined ? undefined : (row.value as T);
  }

  async set<T>(key: string, value: T): Promise<void> {
    await this.db.appSettings.put({ key, value, updatedAt: this.clock.nowIso() });
  }

  async remove(key: string): Promise<void> {
    await this.db.appSettings.delete(key);
  }
}
